import { render, staticRenderFns } from "./home_baiguullaga_ajil_zar.vue?vue&type=template&id=6e223e10&scoped=true&"
import script from "./home_baiguullaga_ajil_zar.vue?vue&type=script&lang=js&"
export * from "./home_baiguullaga_ajil_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e223e10",
  null
  
)

export default component.exports